export enum StorageSnsmApiMode {
  REST = "REST",
  SOAP = "SOAP",
}
